module.exports = __webpack_public_path__ + "img/oneRed.3e556acd.jpg";